import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateMeta } from "../../store/actions/metaAction";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import { checkPermissions } from "../../helpers/authentication/checkPermissions";
import { Link } from "react-router-dom";

const IntroIndex = () => {
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "مقدمات التطبيق",
				breadcrumb: "مقدمات التطبيق",
				button: {
					permissions: ["post-create"],
					show: true,
					text: "اضافة مقدمة جديدة",
					link: "/intro/create",
				},
			})
		);

		axios
			.get(`${process.env.REACT_APP_API_URL}/posts_types/intro`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setData(response.data.data.categories[0].posts);
				setLoading(false);
			})
			.catch(function (error) {
				console.log(error);
				toast.error("خطأ، برجاء المحاولة لاحقا!");
				setLoading(false);
			});
	};

	const handleDelete = postID => {
		axios
			.delete(`${process.env.REACT_APP_API_URL}/posts/${postID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				onStart();
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<section>
				<div className="row">
					{data.map(item => (
						<div className="col-md-3" key={item.id}>
							<div className="serviceItem">
								{checkPermissions(["post-delete"]) && (
									<button onClick={() => handleDelete(item.id)}>
										<i className="fas fa-trash"></i>
									</button>
								)}
								<Link
									to={
										checkPermissions(["post-edit"])
											? `/intro/show/${item.id}`
											: "/"
									}
								>
									<img
										src={`${process.env.REACT_APP_MAIN_URL}${item.data.icon}`}
										alt={item.data.title}
									/>
									<h1>{item.data.title}</h1>
								</Link>
							</div>
						</div>
					))}
				</div>
			</section>
		</section>
	);
};

export default IntroIndex;
